import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const deductionTypesQueryAtom = createQueryAtomFactory(
  'customerPortal.deductionTypes',
  () => ({
    deductionTypes: {
      entries: {
        id: true,
        name: true,
        applicationType: true,
      },
    },
  }),
  {
    select: (data) => data.deductionTypes.entries,
  },
);
